import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _TakeFooter;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@instructure/ui-buttons';
import { PresentationContent, ScreenReaderContent } from '@instructure/ui-a11y-content';
import { jsx } from '@instructure/emotion';
import { ReturnButton } from '@instructure/quiz-core';
import { TakeButton } from '@instructure/quiz-taking';
import t from '@instructure/quiz-i18n/es/format-message';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
export var TakeFooter = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_TakeFooter = /*#__PURE__*/function (_Component) {
  function TakeFooter() {
    var _this;
    _classCallCheck(this, TakeFooter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TakeFooter, [].concat(args));
    _defineProperty(_this, "previousQuestion", function () {
      var msg = t('Moving to previous question');
      _this.props.screenreaderNotification(msg);
      _this.props.previousQuestion();
    });
    return _this;
  }
  _inherits(TakeFooter, _Component);
  return _createClass(TakeFooter, [{
    key: "renderPreviousButton",
    value: function renderPreviousButton() {
      if (!this.props.shouldRenderPrevious) {
        return jsx("div", null);
      }
      return jsx(Button, {
        disabled: this.props.previousButtonDisabled,
        onClick: this.previousQuestion,
        color: "primary-inverse",
        "data-automation": "sdk-oqaat-previous-button"
      }, jsx(ScreenReaderContent, null, t('Previous Question')), jsx(PresentationContent, null, t('Previous')));
    }
  }, {
    key: "renderOQAATFooter",
    value: function renderOQAATFooter() {
      return jsx("div", {
        className: "oqaatFooter",
        css: this.props.styles.oqaatFooter,
        "data-automation": "sdk-take-footer-oqaat-footer"
      }, this.renderPreviousButton(), jsx(TakeButton, {
        onSubmitQuizSession: this.props.onSubmitQuizSession,
        isFooter: true
      }));
    }
  }, {
    key: "renderReturnButton",
    value: function renderReturnButton() {
      if (this.props.returnToUrl) {
        return jsx("div", {
          className: "footer",
          css: this.props.styles.footer
        }, jsx(ReturnButton, {
          returnToUrl: this.props.returnToUrl
        }));
      }
    }
  }, {
    key: "renderStandardFooter",
    value: function renderStandardFooter() {
      return jsx("div", {
        className: "footer",
        css: this.props.styles.footer
      }, this.renderReturnButton(), jsx(TakeButton, {
        onSubmitQuizSession: this.props.onSubmitQuizSession,
        isFooter: true
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.isOneQuestionAtATime ? this.renderOQAATFooter() : this.renderStandardFooter();
    }
  }]);
}(Component), _defineProperty(_TakeFooter, "displayName", 'TakeFooter'), _defineProperty(_TakeFooter, "componentId", "Quizzes".concat(_TakeFooter.displayName)), _defineProperty(_TakeFooter, "propTypes", {
  // TODO: Refactor this component so that it's not relying on props that aren't used internally.  The next 2 props
  // are exclusively used by the redux connecting logic in index.js
  currentSessionItemPosition: PropTypes.number.isRequired,
  quizSessionId: PropTypes.string.isRequired,
  isOneQuestionAtATime: PropTypes.bool.isRequired,
  onSubmitQuizSession: PropTypes.func,
  // consumer provided
  previousButtonDisabled: PropTypes.bool.isRequired,
  returnToUrl: PropTypes.string,
  // consumer provided
  previousQuestion: PropTypes.func.isRequired,
  screenreaderNotification: PropTypes.func.isRequired,
  shouldRenderPrevious: PropTypes.bool.isRequired,
  styles: PropTypes.object
}), _defineProperty(_TakeFooter, "defaultProps", {
  onSubmitQuizSession: function onSubmitQuizSession() {},
  returnToUrl: null
}), _TakeFooter)) || _class);
export default TakeFooter;